export default __webpack_public_path__ + "static/media/79.8152541b.png";